import p5 from "p5";
class Snake {
    p: p5;
    squareSize: number;
    color: number[];
    positions: number[][];
    step: number;
    previousDirection = 0;

    constructor(p: p5, squareSize: number, color: number[], positions: number[][], step: number) {
        this.p = p;
        this.squareSize = squareSize;
        this.color = color;
        this.positions = [...positions];
        this.step = step;
    }

    execute = (mustMove: boolean, mustChangeDirection = true) => {
        for (let i = 0; i < this.positions.length; i++) {
            this.p.noStroke();
            this.p.fill(
                this.p.color(
                    this.color[0] / (this.positions.length - i + 1),
                    this.color[1] / (this.positions.length - i + 1),
                    this.color[2] / (this.positions.length - i + 1)
                )
            );
            this.p.square(
                (this.p.width * 1000 + this.positions[i][0] * this.squareSize) % this.p.width,
                (this.p.height * 1000 + this.positions[i][1] * this.squareSize) % this.p.height,
                this.squareSize
            );
        }
        if (mustMove) {
            this.positions.shift();
            let nextDirection;
            if (mustChangeDirection) {
                nextDirection = Math.floor(Math.random() * 4);
                this.previousDirection = nextDirection;
            } else {
                nextDirection = this.previousDirection;
            }
            let nextPosition;
            switch (nextDirection) {
                case 0:
                    if (
                        !(
                            this.positions[this.positions.length - 2][1] >
                            this.positions[this.positions.length - 1][1]
                        )
                    ) {
                        nextPosition = [
                            this.positions[this.positions.length - 1][0],
                            this.positions[this.positions.length - 1][1] + this.step
                        ];
                    } else {
                        nextPosition = [
                            this.positions[this.positions.length - 1][0],
                            this.positions[this.positions.length - 1][1] - this.step
                        ];
                    }
                    break;
                case 1:
                    if (
                        !(
                            this.positions[this.positions.length - 2][0] >
                            this.positions[this.positions.length - 1][0]
                        )
                    ) {
                        nextPosition = [
                            this.positions[this.positions.length - 1][0] + this.step,
                            this.positions[this.positions.length - 1][1]
                        ];
                    } else {
                        nextPosition = [
                            this.positions[this.positions.length - 1][0] - this.step,
                            this.positions[this.positions.length - 1][1]
                        ];
                    }
                    break;
                case 2:
                    if (
                        !(
                            this.positions[this.positions.length - 2][1] <
                            this.positions[this.positions.length - 1][1]
                        )
                    ) {
                        nextPosition = [
                            this.positions[this.positions.length - 1][0],
                            this.positions[this.positions.length - 1][1] - this.step
                        ];
                    } else {
                        nextPosition = [
                            this.positions[this.positions.length - 1][0],
                            this.positions[this.positions.length - 1][1] + this.step
                        ];
                    }
                    break;
                case 3:
                    if (
                        !(
                            this.positions[this.positions.length - 2][0] <
                            this.positions[this.positions.length - 1][0]
                        )
                    ) {
                        nextPosition = [
                            this.positions[this.positions.length - 1][0] - this.step,
                            this.positions[this.positions.length - 1][1]
                        ];
                    } else {
                        nextPosition = [
                            this.positions[this.positions.length - 1][0] + this.step,
                            this.positions[this.positions.length - 1][1]
                        ];
                    }
                    break;
                default:
                    throw new Error("Something went wrong in Contact Sketch!");
            }
            this.positions.push(nextPosition);
        }
    };
}

const sketch = (p: p5) => {
    const fr = 20;

    p.setup = () => {
        p.frameRate(fr);
        p.createCanvas(window.innerWidth, window.innerHeight - 52);
    };

    let snake1 = new Snake(
        p,
        16,
        [127, 63, 63],
        [
            [0, 0],
            [1, 0],
            [2, 0],
            [3, 0]
        ],
        1
    );

    let snake2 = new Snake(
        p,
        12,
        [191, 63, 191],
        [
            [4, 0],
            [4, 1],
            [4, 2],
            [4, 3],
            [4, 4],
            [4, 5],
            [4, 6],
            [4, 7],
            [4, 8],
            [4, 9]
        ],
        1
    );

    let snake3 = new Snake(
        p,
        8,
        [255, 255, 255],
        [
            [32, 0],
            [32, 2],
            [32, 4],
            [32, 6],
            [32, 8],
            [32, 10],
            [32, 12],
            [32, 14],
            [32, 16],
            [32, 18],
            [32, 20],
            [32, 22],
            [32, 24],
            [32, 26],
            [32, 28]
        ],
        2
    );

    p.draw = () => {
        p.background(0);
        let index = p.frameCount;
        snake1.execute(index % 2 < 1);
        snake2.execute(index % 3 < 1);
        snake3.execute(index % 1 < 1, p.frameCount % 3 === 0);
    };

    p.windowResized = () => {
        p.resizeCanvas(p.windowWidth, p.windowHeight - 52);
    };
};

export default sketch;
